import {
  UPDATE_CONTENT,
} from "./actionTypes";

const initialState = {
  data: null,
};

export const content = (state = initialState, action) => {
  if(action.type === UPDATE_CONTENT){
    return {
      ...state,
      data: action.payload,
    }
  }

  return state;
}